import { useDxfMappingSubject } from 'modules/common/viewer/dxfViewer/mapping/hooks/useDxfMappingSubject';
import { useDxfMappingActions } from 'modules/common/viewer/dxfViewer/mapping/mappingActions';
import type { DxfViewerSession } from 'modules/common/viewer/dxfViewer/session/types';
import { useReadableStore } from 'modules/common/viewer/dxfViewer/session/useSessionState';

/**
 * How the side panels clear the toolbar floating over the canvas: below
 * `containerQuery`'s width the toolbar reaches the panels, so they move down to
 * `top`.
 *
 * Mapping mode's wider toolbar pushes that collision out (~840px to ~1040px), and
 * the split banner it may show underneath is stretched to the same width, so it
 * only moves `top` further down.
 */
export const useDxfSidePanelsClearance = (session: DxfViewerSession) => {
  const mode = useReadableStore(session.mode);
  const mapping = useDxfMappingSubject(session);
  const { splitToLineItems } = useDxfMappingActions();
  const isSplitBannerVisible =
    mapping !== null && splitToLineItems.getIsVisible(mapping);

  return {
    containerQuery: `@container viewer-content (max-width: ${
      mode === 'mapping' ? '1060px' : '860px'
    })`,
    top: isSplitBannerVisible ? '6.75rem' : '3rem',
  };
};
